﻿import {IProgress} from "@2d-front-monorepo/core";
import {ProgressReporter} from "./progressReporter";

export default function reportProgress(progress: IProgress, reporter?: ProgressReporter): void {
	if (reporter != null) reporter(progress);
}
